(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/payment-history.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/payment-history.js');
'use strict';

const {
  Card,
  CardHeader
} = svs.ui.ReactCard;
const {
  Loader
} = svs.components.ReactLoader;
const {
  dialog
} = svs.components;
const PaymentHistory = () => {
  const [clubs, setClubs] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const {
    getHightchartOptions
  } = svs.grassroots_partner.usePaymentHistory();
  const displayFetchError = () => {
    setError(true);
    const branding = svs.core.detect.tenant('tb') ? dialog.branding.TUR : dialog.branding.SPORT;
    dialog.api.add(new dialog.Confirm({
      branding,
      type: dialog.type.ERROR,
      title: 'Något gick fel!',
      message: [{
        type: dialog.message.TEXT,
        text: 'Hämtning av utbetalningshistorik misslyckades'
      }],
      actions: [{
        title: 'STÄNG'
      }]
    }));
  };
  React.useEffect(() => {
    setError(false);
    const options = {
      method: 'GET',
      path: '/partner/1/sponsorship/receiverinfointernal'
    };
    svs.core.jupiter.get(options, (data, status) => {
      if (status === 'success') {
        setClubs(data.receivers);
      } else {
        displayFetchError();
      }
      setLoading(false);
    }, () => {
      setLoading(false);
      displayFetchError();
    });
  }, []);
  return React.createElement("div", null, !error && (loading ? React.createElement(Loader, null) : React.createElement(Card, null, React.createElement(CardHeader, {
    align: "center"
  }, React.createElement("h5", {
    className: "card-header-title"
  }, "Utbetalningar")), React.createElement("div", {
    className: "grid-row padding-2"
  }, clubs.map(club => React.createElement("div", {
    className: "col-xs-12 col-md-6 padding-2",
    key: club.id
  }, React.createElement(svs.components.libs.ReactHighcharts, {
    highcharts: svs.components.libs.Highcharts,
    options: getHightchartOptions(club)
  })))))));
};
svs.grassroots_partner.PaymentHistory = PaymentHistory;

 })(window);